import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

/**
 * A voice's loudness as bars (levels 0 to 1, early to late). Bars scale,
 * so a live meter redraws without re-laying anything.
 */
export const LevelBars = memo(
  ({ levels, color }: { levels: readonly number[]; color: string }) => {
    const { rpx } = useResponsiveContext();
    const height = rpx(18);
    return (
      <View
        style={{ flexDirection: 'row', alignItems: 'center', gap: 2, height }}
      >
        {levels.map((level, i) => (
          <View
            key={i}
            style={{
              width: 3,
              height,
              borderRadius: 1.5,
              backgroundColor: color,
              transform: [{ scaleY: 0.15 + Math.min(1, level) * 0.85 }],
            }}
          />
        ))}
      </View>
    );
  },
);
